import styled from "styled-components";
import OrderFormRow from "./OrderFormRow";

export const OrderFormRequestInfo = styled.div`
  font-size: 12px;
`;

export const OrderFormRequestFooter = styled(OrderFormRow)`
  position: relative;

  .add-button {
    margin: 12px 0 0 36px;
  }
  
  .uwis-count {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;

    input {
      width: 42px;
      background-color: #D9D9D9;
      border-color: #CCC;
      text-align: center;
    }
  }
`;

export default styled(OrderFormRow)<{ $isRemoveButtonVisible: boolean; }>`
  .request-row {
    display: flex;
  }

  .uwi-item {
    display: flex;
    align-items: center;
  }

  .uwi-item-number {
    min-width: 24px;
    margin-right: 12px;
    font-size: 12px;
    text-align: right;
  }

  .uwi-item-input {
    flex-grow: 1;

    
    input {
      ${props => props.$isRemoveButtonVisible && `
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      `}
    }
  }

  .uwi-btn-remove {
    button {
      border: 1px solid #D9D9D9;
      border-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .ant-form-item-explain-error {
    margin-left: 38px;
  }
`;
